import {captureTokenAuthError, sweetAPI} from 'app/store/sweet-api';
import {
  REPORTS_API_URL,
  REPORTSRUN_API_URL,
  REPORTSRUN_CREATE_API_URL,
} from 'app/urls';

import {
  ListResponseType,
  ReportResultSerializedType,
  ReportSerializedType,
} from 'sweet-types';

import type {ReportJobSerializedType} from './types';

type ReportRunParams = {
  ends_at: string;
  starts_at: string;
  slug: string;
};

export const extendedAPI = sweetAPI.injectEndpoints({
  endpoints: (build) => ({
    getReports: build.query<ListResponseType<ReportSerializedType>, void>({
      query: () => REPORTS_API_URL,
      onQueryStarted: async (args, {queryFulfilled, ...api}) => {
        queryFulfilled.catch((result) => {
          captureTokenAuthError(result.error as any, api, [
            'required-not-in-scope',
          ]);
        });
      },
    }),
    getReport: build.query<ReportSerializedType, string>({
      query: (slug: string) => `${REPORTS_API_URL}${slug}/`,
      onQueryStarted: async (args, {queryFulfilled, ...api}) => {
        queryFulfilled.catch((result) => {
          captureTokenAuthError(result.error as any, api, [
            'required-not-in-scope',
          ]);
        });
      },
    }),
    runReport: build.mutation<{job: ReportJobSerializedType}, ReportRunParams>({
      query: (body) => ({
        url: REPORTSRUN_CREATE_API_URL,
        method: 'POST',
        body,
      }),
    }),
    getReportRun: build.query<ReportResultSerializedType, string>({
      query: (id: string) => `${REPORTSRUN_API_URL}${id}/`,
      onQueryStarted: async (args, {queryFulfilled, ...api}) => {
        queryFulfilled.catch((result) => {
          captureTokenAuthError(result.error as any, api, [
            'required-not-in-scope',
          ]);
        });
      },
    }),
  }),
});

// https://redux-toolkit.js.org/rtk-query/usage/queries#hook-types
export const {
  useQuery: useReports,
  useLazyQuery: useLazyReports,
  useQueryState: useReportsState,
} = extendedAPI.endpoints.getReports;

export const {useQuery: useReportDetail} = extendedAPI.endpoints.getReport;

export const {useMutation: useRunReport} = extendedAPI.endpoints.runReport;

export const {useQuery: useReportRunDetail} =
  extendedAPI.endpoints.getReportRun;
